import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";

export default function AudienceSection({ type, title, subtitle }) {
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth"
      });
    }
  };

  const investorBenefits = [
    "Exclusive gateway to Ukraine’s defence innovation",
    "Access to Europe’s accelerating defence growth wave",
    "Structural tailwinds from NATO and EU budgets",
    "Benefit from our experience without direct risk",
    "Deep industry insight identifying high-potential niche players",
    "Diversified investments across multiple companies"
  ];

  const founderBenefits = [
    "Growth capital aligned to defence demand, not hype cycles",
    "Grants, co-funding, and public-program access across EU and Ukraine",
    "JV creation between Ukrainian manufacturers and EU/NATO suppliers",
    "Industrial scale-up and supply-chain execution for delivery contracts",
    "Certifications and compliance to unlock Tier-1 customers",
    "Direct access to NATO, EU, and Middle East buyers"
  ];

  const benefits = type === "investors" ? investorBenefits : founderBenefits;
  const bgColor = type === "investors" ? "bg-[#0B1C2C]" : "bg-[#0F2437]";
  const ctaText = type === "investors" ? "Speak to IR Team" : "Submit Your Opportunity";

  return (
    <div className={`${bgColor} py-24`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {title}
            </h2>
            <p className="text-xl text-[#6B7C93] mb-8">
              {subtitle}
            </p>
            <Button 
              onClick={scrollToContact}
              className="bg-[#24A19C] hover:bg-[#1d8a85] text-white px-8 py-6 text-lg rounded-lg font-medium transition-all duration-200 hover:shadow-xl hover:shadow-[#24A19C]/20"
            >
              {ctaText}
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <Card className="bg-white/5 border-[#24A19C]/20 backdrop-blur-sm">
              <CardContent className="p-8">
                <div className="space-y-4">
                  {benefits.map((benefit, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, x: 20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 }}
                      className="flex items-start gap-3"
                    >
                      <div className="bg-[#24A19C]/20 p-1.5 rounded-full mt-0.5">
                        <CheckCircle2 className="w-5 h-5 text-[#24A19C]" />
                      </div>
                      <p className="text-white leading-relaxed flex-1">
                        {benefit}
                      </p>
                    </motion.div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </div>
  );
}